import React, { useState } from "react";
import img49 from "../images/image49.png";
import img51 from "../images/image51.png";
import img52 from "../images/image52.png";
import img53 from "../images/image53.png";
import img54 from "../images/image54.png";
import img55 from "../images/image55.png";
import img56 from "../images/image56.png";
import Footer from "../Footer";

const data = [
  {
    id: 7,
    image: img56,
    title: "Impact Investing",
    text: "On April 23, 2024, TISSAA-VAANI hosted a webinar on 'Impact Investing' featuring Ms. Anshu Bhartia, Co-Founder of ",
    fullText:
      "On April 23, 2024, TISSAA-VAANI hosted a webinar on 'Impact Investing' featuring Ms. Anshu Bhartia, Co-Founder of Forvity Consulting and former CEO of UnLtd India. The session highlighted the role of impact investing in driving social change, evaluating social ventures, and aligning business strategy with sustainability. Ms. Bhartia emphasized the importance of market value for long-term success, and the session also discussed how TISS Alums can support social enterprises and promote impact investments.",
  },
  
  {
    id: 5,
    image: img54,
    title: "Understanding ESG",
    text: "The TISSAA-VAANI webinar on 'Understanding ESG' featured industry leaders Gunjan Patel (Microsoft), Shalini Singh (PVR), and",
    fullText:
      "The TISSAA-VAANI webinar on 'Understanding ESG' featured industry leaders Gunjan Patel (Microsoft), Shalini Singh (PVR), and Sangeeta Robinson (PVR). This session offered critical insights into Environmental, Social, and Governance (ESG) principles, empowering Alums to integrate sustainable practices into their professional journeys. The event explored how ESG factors influence business decision-making and the long-term impact on sustainability efforts.",
  },
  
  {
    id: 3,
    image: img52,
    title: "Image Management for Professional Growth",
    text: "The TISSAA-VAANI webinar on 'Image Management for Professional Growth,",
    fullText:
      "The TISSAA-VAANI webinar on 'Image Management for Professional Growth,' conducted by Sobins Kuriakose, World Bank Consultant, offered valuable insights into crafting and enhancing professional narratives. The 45-minute session empowered participants with strategies to shape their career trajectories effectively by focusing on image management as a key component of professional development.",
  },
  {
    id: 6,
    image: img55,
    title: "Understanding the Tata Way of Volunteering",
    text: "TISSAA-VAANI hosted an enriching session titled 'Understanding the Tata Way of",
    fullText:
      "TISSAA-VAANI hosted an enriching session titled 'Understanding the Tata Way of Volunteering,' led by Shri Shrirang Dhavale, Cluster Head at Tata Sustainability Group, Tata Sons. The session delved into the Tata Group's extensive corporate volunteering program, highlighting its global impact and the learning opportunities it offers. The webinar provided valuable insights into the Tata Group’s approach to social responsibility and corporate volunteering, inspiring Alums to get involved in similar initiatives.",
  },
  {
    id: 2,
    image: img51,
    title: "Resource Mobilization and Management for Startups, NGOs, and Alums-Led Companies",
    text: "The TISSAA-VAANI webinar on 'Resource Mobilization and Management for",
    fullText:
      "The TISSAA-VAANI webinar on 'Resource Mobilization and Management for Startups, NGOs, and Alums-Led Companies' featured insights from Ravi Jaiselmeria, Founder of Growthally, and Ajay Govale, VP of Community Impact at United Way Mumbai. This session provided valuable strategies for driving growth and ensuring sustainability in startups, NGOs, and Alums-led businesses, offering Alums tools to effectively mobilize and manage resources for organizational success.",
  },
  {
    id: 1,
    image: img49,
    title: "Evolution of Carbon Credits",
    text: "The TISSAA-VAANI webinar on carbon credits, held on May 26, 2024, featured experts Deepak Pandey, CEO of Suvidha, and Kavya Hari, Principal at Intellecap. The session explored how",
    fullText:
      "The TISSAA-VAANI webinar on carbon credits, held on May 26, 2024, featured experts Deepak Pandey, CEO of Suvidha, and Kavya Hari, Principal at Intellecap. The session explored how carbon credits contribute to environmental sustainability and how they can be integrated into organizational strategies. The webinar also discussed the career opportunities created by this emerging field, offering valuable insights for Alums interested in environmental impact and sustainability.",
  },
  
  {
    id: 4,
    image: img53,
    title: "Diversity, Equity, and Inclusion (DEI) in Business",
    text: "The TISSAA-VAANI webinar on 'The Importance of Diversity, Equity, and Inclusion (DEI) in Business' provided valuable insights on fostering inclusive",
    fullText:
      "The TISSAA-VAANI webinar on 'The Importance of Diversity, Equity, and Inclusion (DEI) in Business' provided valuable insights on fostering inclusive practices in professional settings. Participants learned from experts about the significance of DEI in driving business success and the social impact of advancing equity within organizations. The session focused on practical guidance for integrating DEI principles into business strategies and organizational culture.",
  },
  
  
  
];
const Vaani = () => {
  const [modalData, setModalData] = useState(null);

  const openModal = (item) => {
    setModalData(item);
  };

  const closeModal = () => {
    setModalData(null);
  };

  return (
    <div>
    <div style={{ padding: "20px" }}>
      
      <p
        style={{
          fontSize: "1.2rem",
          marginBottom: "30px",
          fontFamily: "Tahoma",
          marginLeft: "15px",
          textAlign: "justify",
          marginRight:"15px",
        }}
      >
        TISSAA-VAANI is a monthly webinar series hosted by TISSAA, focusing on
        important and relevant topics based on Alums' interests. These sessions
        feature expert Alums and professionals in various fields, covering
        topics such as social stock exchange, ESG, and impact investing. The webinars provide a platform for Alums to network, share knowledge, and
         engage in discussions that contribute to professional growth. Sessions are promoted through engaging content, recorded
         for broader reach, and feedback is collected to enhance future interactions, fostering stronger ties within the Alums
        community.
      </p>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "190px",
          justifyContent: "center",
        }}
      >
        {data.map((item) => (
          <div
            key={item.id}
            style={{
              width: "300px",
              border: "1px solid #ddd",
              borderRadius: "10px",
              overflow: "hidden",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            }}
          >
            <img
              src={item.image}
              alt={item.title}
              style={{ width: "100%", height: "200px", objectFit: "cover" }}
            />
            <div style={{ padding: "15px" }}>
              <h2
                style={{
                  fontSize: "1.5rem",
                  marginBottom: "10px",
                  fontFamily: "Inter",
                }}
              >
                {item.title}
              </h2>
              <p
                style={{
                  fontSize: "1rem",
                  fontFamily: "Tahoma",
                  marginBottom: "10px",
                }}
              >
                {item.text}
              </p>
              <button
                onClick={() => openModal(item)}
                style={{
                  backgroundColor: "#007BFF",
                  color: "#fff",
                  border: "none",
                  padding: "8px 12px",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                Read More
              </button>
            </div>
          </div>
        ))}
      </div>

      {modalData && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
          onClick={closeModal}
        >
          <div
            style={{
              backgroundColor: "#fff",
              borderRadius: "10px",
              width: "80%",
              maxWidth: "600px",
              padding: "20px",
              position: "relative",
              textAlign: "center",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={closeModal}
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                background: "none",
                border: "none",
                fontSize: "1.5rem",
                cursor: "pointer",
              }}
            >
              &times;
            </button>
            <img
              src={modalData.image}
              alt={modalData.title}
              style={{
                width: "100%",
                height: "300px",
                objectFit: "contain",
                marginBottom: "20px",
              }}
            />
            <h2
              style={{
                fontSize: "1.5rem",
                fontFamily: "Inter",
                marginBottom: "15px",
              }}
            >
              {modalData.title}
            </h2>
            <p
              style={{
                fontSize: "1rem",
                fontFamily: "Tahoma",
              }}
            >
              {modalData.fullText}
            </p>
          </div>
        </div>
      )}
      </div>
      <Footer/>
    </div>
  );
};

export default Vaani;


// import React from "react";
// import img49 from '../images/image49.png';
// import img51 from '../images/image51.png';
// import img52 from '../images/image52.png';
// import img53 from '../images/image53.png';
// import img54 from '../images/image54.png';
// import img55 from '../images/image55.png';
// import img56 from '../images/image56.png';

// const Vaani = () => {
//   return (
//     <div style={{ padding: "20px" }}>
//       <h1 style={{ textAlign: "center", fontSize: "2.5rem", marginBottom: "20px", fontFamily: "Inter" }}>
//         TISSAA-VAANI
//       </h1>
//       <p style={{ fontSize: "1.2rem", marginBottom: "30px", fontFamily: "Tahoma", marginLeft: "15px" }}>
//         TISSAA-VAANI is a monthly webinar series hosted by TISSAA, focusing on important and relevant topics based on Alums'
//         interests. These sessions feature expert Alums and professionals in various fields, covering topics such as social
//         stock exchange, ESG, and impact investing. The webinars provide a platform for Alums to network, share knowledge, and
//         engage in discussions that contribute to professional growth. Sessions are promoted through engaging content, recorded
//         for broader reach, and feedback is collected to enhance future interactions, fostering stronger ties within the Alums
//         community.
//       </p>

      
//       <div style={{ display: "flex", alignItems: "center", gap: "20px", marginBottom: "30px" }}>
//   <div style={{ flex: 1 }}>
//     <h2 style={{ fontSize: "2rem", marginBottom: "20px", fontFamily: "Inter" }}>
//       Evolution of Carbon Credits
//     </h2>
//     <p style={{ fontSize: "1.2rem", fontFamily: "Tahoma", marginLeft: "15px" }}>
//       The TISSAA-VAANI webinar on carbon credits, held on May 26, 2024, featured experts Deepak Pandey, CEO of Suvidha, and
//       Kavya Hari, Principal at Intellecap. The session explored how carbon credits contribute to environmental sustainability
//       and how they can be integrated into organizational strategies. The webinar also discussed the career opportunities
//       created by this emerging field, offering valuable insights for Alums interested in environmental impact and sustainability.
//     </p>
//   </div>

//       <div style={styles.imageContainer}>
//         <img src={img49} alt="Alumni Meet 1" style={{ ...styles.image, float:"right",height: "80%", width:"100%",marginLeft:"90px" , marginRight: "20px", marginBottom: "60px",objectFit: "cover"}} />
//       </div></div>

//       <h2 style={{ fontSize: "2rem", marginBottom: "20px", fontFamily: "Inter" }}>Impact Investing</h2>
//       <p style={{ width: "60%",float: "right", fontSize: "1.2rem", marginBottom: "30px", fontFamily: "Tahoma", marginLeft: "15px" }}>
//         On April 23, 2024, TISSAA-VAANI hosted a webinar on "Impact Investing" featuring Ms. Anshu Bhartia, Co-Founder of Forvity
//         Consulting and former CEO of UnLtd India. The session highlighted the role of impact investing in driving social change,
//         evaluating social ventures, and aligning business strategy with sustainability. Ms. Bhartia emphasized the importance of
//         market value for long-term success, and the session also discussed how TISS Alums can support social enterprises and
//         promote impact investments.
//       </p>
//       <div style={styles.imageContainer}>
//         <img src={img56} alt="Alumni Meet 1" style={{ ...styles.image, float:"left", width:"60%", height: "auto"}} />
//       </div>

//       <h2 style={{ fontSize: "2rem", marginBottom: "20px", fontFamily: "Inter" }}>
//         Resource Mobilization and Management for Startups, NGOs, and Alums-Led Companies</h2>
//       <p style={{width: "50%",float: "left", fontSize: "1.2rem", marginBottom: "30px", fontFamily: "Tahoma", marginLeft: "15px" }}>
//         The TISSAA-VAANI webinar on "Resource Mobilization and Management for Startups, NGOs, and Alums-Led Companies" featured
//         insights from Ravi Jaiselmeria, Founder of Growthally, and Ajay Govale, VP of Community Impact at United Way Mumbai. This
//         session provided valuable strategies for driving growth and ensuring sustainability in startups, NGOs, and Alums-led
//         businesses, offering Alums tools to effectively mobilize and manage resources for organizational success.
//       </p>
//       <div style={styles.imageContainer}>
//         <img src={img51} alt="Alumni Meet 1" style={{ ...styles.image, float:"right", width:"90%" }} />
//       </div>

//       <h2 style={{ fontSize: "2rem", marginBottom: "20px", fontFamily: "Inter" }}>Image Management for Professional Growth</h2>
//       <p style={{width: "60%",float: "right", fontSize: "1.2rem", marginBottom: "30px", fontFamily: "Tahoma", marginLeft: "15px" }}>
//         The TISSAA-VAANI webinar on "Image Management for Professional Growth," conducted by Sobins Kuriakose, World Bank Consultant,
//         offered valuable insights into crafting and enhancing professional narratives. The 45-minute session empowered participants
//         with strategies to shape their career trajectories effectively by focusing on image management as a key component of
//         professional development.
//       </p>
//       <div style={styles.imageContainer}>
//         <img src={img52} alt="Alumni Meet 1" style={{ ...styles.image, float:"left", width:"90%"}} />
//       </div>

//       <h2 style={{ fontSize: "2rem", marginBottom: "20px", fontFamily: "Inter" }}>
//         Diversity, Equity, and Inclusion (DEI) in Business</h2>
//       <p style={{width: "50%",float: "left", fontSize: "1.2rem", marginBottom: "30px", fontFamily: "Tahoma", marginLeft: "15px" }}>
//         The TISSAA-VAANI webinar on "The Importance of Diversity, Equity, and Inclusion (DEI) in Business" provided valuable insights
//         on fostering inclusive practices in professional settings. Participants learned from experts about the significance of DEI
//         in driving business success and the social impact of advancing equity within organizations. The session focused on practical
//         guidance for integrating DEI principles into business strategies and organizational culture.
//       </p>
//       <div style={styles.imageContainer}>
//         <img src={img53} alt="Alumni Meet 1" style={{ ...styles.image, float:"right", width:"90%" }} />
//       </div>

//       <h2 style={{ fontSize: "2rem", marginBottom: "20px", fontFamily: "Inter" }}>Understanding ESG</h2>
//       <p style={{width: "60%",float: "right", fontSize: "1.2rem", marginBottom: "30px", fontFamily: "Tahoma", marginLeft: "15px" }}>
//         The TISSAA-VAANI webinar on "Understanding ESG" featured industry leaders Gunjan Patel (Microsoft), Shalini Singh (PVR), and
//         Sangeeta Robinson (PVR). This session offered critical insights into Environmental, Social, and Governance (ESG) principles,
//         empowering Alums to integrate sustainable practices into their professional journeys. The event explored how ESG factors
//         influence business decision-making and the long-term impact on sustainability efforts.
//       </p>
//       <div style={styles.imageContainer}>
//         <img src={img54} alt="Alumni Meet 1" style={{ ...styles.image, float:"left", width:"90%"}} />
//       </div>

//       <h2 style={{ fontSize: "2rem", marginBottom: "20px", fontFamily: "Inter" }}>
//         Understanding the Tata Way of Volunteering
//       </h2>
//       <p style={{width: "50%",float: "left", fontSize: "1.2rem", marginBottom: "30px", fontFamily: "Tahoma", marginLeft: "15px" }}>
//         TISSAA-VAANI hosted an enriching session titled "Understanding the Tata Way of Volunteering," led by Shri Shrirang Dhavale,
//         Cluster Head at Tata Sustainability Group, Tata Sons. The session delved into the Tata Group's extensive corporate volunteering
//         program, highlighting its global impact and the learning opportunities it offers. The webinar provided valuable insights into
//         the Tata Group’s approach to social responsibility and corporate volunteering, inspiring Alums to get involved in similar
//         initiatives.
//       </p>
//       <div style={styles.imageContainer}>
//         <img src={img55} alt="Alumni Meet 1" style={{ ...styles.image, float:"right", width:"90%" }} />
//       </div>
//     </div>
//   );
// };

// const styles = {
//   imageContainer: {
//     display: 'grid',
//     gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
//     gap: '15px',
//     marginBottom: '40px',
//     justifyItems: 'center',
//     alignItems: 'center',
//   },
//   image: {
//     width: '100%',
//     height: 'auto',
//     borderRadius: '8px',
//     boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
//     transition: 'transform 0.3s ease, box-shadow 0.3s ease',
//   },
//   imageHover: {
//     transform: 'scale(1.05)',
//     boxShadow: '0 6px 16px rgba(0, 0, 0, 0.15)',
//   }
// };
// export default Vaani;
